
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommOrderPromoEditor extends Common.GridEditorBase<ECommOrderPromoRow> {
        protected getColumnsKey() { return 'ECommerce.ECommOrderPromo'; }
        protected getDialogType() { return ECommOrderPromoDialog; }
        protected getLocalTextPrefix() { return ECommOrderPromoRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        public getData(PromoDetails) {
            var tmp = [];
            for (let Detail of PromoDetails) {
                Detail[this.getIdProperty()] = "`" + this.nextId++;
                var x = Detail;
                tmp.push(Detail);
            }
            return tmp;

        }
    }
}